"use client";

import viugoFilterLiveIcon from "@/assets/images/viugo/kbv-v16-filter-live-icon.svg";
import viugoFilterFlameIcon from "@/assets/images/viugo/kbv-v16-filter-flame-icon.svg";

const LIVE_BG = "var(--text-half-score)";

const pillBase =
    "shrink-0 flex min-h-[34px] cursor-pointer select-none items-center justify-center gap-0.5 whitespace-nowrap rounded-[4px] px-2.5 py-[5px] text-center text-[12px] transition-colors min-w-max";

/**
 * Horizontal date / live / hot filter strip.
 */
export default function ViuGoListFilterDate({
    dateOptions,
    selectedDate,
    onDateChange,
    isHotOnly,
    onToggleHot,
    liveLabel,
}) {
    const liveOpt = dateOptions.find((o) => o.type === "live");
    const restOptions = dateOptions.filter((o) => o.type !== "live");
    const liveText = liveLabel ?? liveOpt?.label ?? "Live";

    const pickDate = (value) => {
        onDateChange(value);
    };

    return (
        <div
            className="flex w-full flex-nowrap items-center gap-2.5 overflow-x-auto overflow-y-hidden max-md:scrollbar-hide [scrollbar-width:thin] [scrollbar-color:var(--theme-filter-active-bg,var(--theme-filter-active-bg))_transparent] [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-[var(--theme-filter-active-bg,var(--theme-filter-active-bg))]"
        >
            {liveOpt && (
                <button
                    type="button"
                    onClick={() => pickDate(liveOpt.value)}
                    className={`${pillBase} font-medium text-white`}
                    style={{ backgroundColor: LIVE_BG }}
                >
                    <span className="relative inline-flex shrink-0 items-center">
                        <img src={viugoFilterLiveIcon} alt="" width={17} height={16} className="shrink-0" aria-hidden />
                    </span>
                    <span>{liveText}</span>
                </button>
            )}

            <button
                type="button"
                onClick={onToggleHot}
                className={`${pillBase} text-[var(--theme-text)] !bg-[var(--theme-accent)] border border-solid ${
                    isHotOnly ? "border-[var(--theme-live-chip-bg,var(--theme-live-chip-bg))]" : "border-transparent"
                }`}
            >
                <img src={viugoFilterFlameIcon} alt="" width={24} height={24} className="shrink-0" aria-hidden />
                <span>Trận hot</span>
            </button>

            {restOptions.map((opt) => {
                const isDateSelected = selectedDate === opt.value && !isHotOnly;

                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => pickDate(opt.value)}
                        className={`${pillBase} text-[var(--theme-text)] ${
                            isDateSelected
                                ? "!bg-[var(--theme-filter-active-bg,var(--theme-filter-active-bg))]"
                                : "!bg-[var(--theme-accent)]"
                        }`}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}
